import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "email-verification-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Verifica email", -1)
const _hoisted_3 = {
  key: 0,
  class: "p-d-flex p-flex-column p-align-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Email verificata con successo", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Non siamo riusciti a verificare il tuo indirizzo email. Contatta l'assistenza GoVolt", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Verifica in corso...", -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GvSpinner = _resolveComponent("GvSpinner")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_GvSpinner, {
      "is-loading": _ctx.state.verificationInProgress
    }, null, 8, ["is-loading"]),
    _createVNode(_component_Toast, { position: "top-center" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.state.isEmailVerified && !_ctx.state.verificationInProgress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_Button, {
              class: "gv-button",
              label: _ctx.nextUrl !== '' ? 'Imposta password' : 'Val al login',
              onClick: _ctx.goToLogin
            }, null, 8, ["label", "onClick"])
          ]))
        : (!_ctx.state.isEmailVerified && !_ctx.state.verificationInProgress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : (_ctx.state.verificationInProgress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            : _createCommentVNode("", true)
    ])
  ], 64))
}